import { GlobalStyles } from "@mui/material";
import { SnackbarProvider, SnackbarProviderProps } from "notistack";
import { FC } from "react";
import { Colors } from "../style/Colors";

export const CustomSnackbarProvider: FC<SnackbarProviderProps> = ({ children, ...props }) => {
  return (
    <>
      <GlobalStyles
        styles={{
          ".SnackbarItem-variantWarning": {
            backgroundColor: `${Colors.orange} !important`,
          },
        }}
      />
      <SnackbarProvider {...props}>{children}</SnackbarProvider>
    </>
  );
};
